import { render, staticRenderFns } from "./StripImportSiq.vue?vue&type=template&id=1fa435d8&"
import script from "./StripImportSiq.vue?vue&type=script&lang=js&"
export * from "./StripImportSiq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports